// Date formatters shared between Imperative views (table row + detail dialog).
// Inputs are ISO date strings ("YYYY-MM-DD") from the server; rendering uses
// the browser's locale via toLocaleDateString.

export function formatDate(dateString) {
  if (!dateString) return ""
  const date = new Date(dateString + "T00:00:00")
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  })
}

export function formatDateRange(startDate, endDate) {
  if (!startDate && !endDate) return ""
  const start = formatDate(startDate)
  const end = formatDate(endDate)
  if (start && end) return `${start} – ${end}`
  if (start) return `From ${start}`
  return `Until ${end}`
}
